import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import '../Roles/roles.css';
import './organizations.css';
import { Pagination } from '../../../components/common/Pagination';
import { OrganizationsTable } from './OrganizationsTable';
import { OrganizationsTableSkeleton } from './OrganizationsTableSkeleton';
import { MobileOrganizationCard } from './MobileOrganizationCard';
import { MobileCardSkeleton } from '../../../components/common/MobileCardSkeleton/MobileCardSkeleton';
import { ListPageLayout } from '../components/ListPageLayout';
import { ListPageToolbar } from '../components/ListPageToolbar';
import { useOrganizationsPage } from './hooks/useOrganizationsPage';
import { ORGANIZATIONS_ROLES_SECTION } from '../../../layouts/DashboardV2Layout/dashboardSections';
import { organizationCreatePath, organizationEditPath } from '../../../constants/routes';

export const OrganizationsV2 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const page = useOrganizationsPage();
  const openCreate = () => navigate(organizationCreatePath());

  return (
    <>
      <ListPageLayout
        section={ORGANIZATIONS_ROLES_SECTION}
        desktopToolbar={
          <ListPageToolbar
            searchValue={page.search}
            onSearchChange={page.setSearch}
            searchPlaceholder={t('dashboard.organizations.searchPlaceholder')}
            countText={t('dashboard.organizations.displayingOfTotal', {
              count: page.organizations.length,
              total: page.total,
            })}
            actionLabel={t('dashboard.organizations.create')}
            onAction={openCreate}
          />
        }
        showLoading={page.showLoading}
        isLoading={page.showLoading}
        hasError={Boolean(page.listError)}
        errorMessage={page.listErrorMessage}
        onRetry={() => void page.refetch()}
        itemCount={page.organizations.length}
        emptyState={{ icon: 'domain', message: t('dashboard.organizations.empty') }}
        table={
          <>
            <OrganizationsTable organizations={page.organizations} />
            <Pagination
              total={page.total}
              page={page.pageIndex}
              rowsPerPage={page.rowsPerPage}
              onPageChange={page.handlePageChange}
              onRowsPerPageChange={page.handleRowsPerPageChange}
            />
          </>
        }
        tableSkeleton={<OrganizationsTableSkeleton />}
        mobileTitle={t('dashboard.sidebar.organizationsRoles')}
        mobileHeaderAction={
          <button
            type="button"
            className="mobile-icon-btn"
            onClick={openCreate}
            aria-label={t('dashboard.organizations.create')}
          >
            <span className="material-symbols-outlined">add</span>
          </button>
        }
        mobileCountText={t('dashboard.organizations.allWithCount', { count: page.total })}
        search={{
          value: page.search,
          onChange: page.setSearch,
          placeholder: t('dashboard.organizations.searchPlaceholder'),
          inputProps: { type: 'text', name: 'mobile-organization-search' },
        }}
        mobileCards={page.organizations.map((organization) => (
          <MobileOrganizationCard
            key={organization.id}
            organization={organization}
            onEdit={() => navigate(organizationEditPath(organization.id))}
          />
        ))}
        mobileSkeleton={<MobileCardSkeleton showFooter={false} idValueWidth="8rem" />}
        pagination={{
          total: page.total,
          page: page.pageIndex,
          rowsPerPage: page.rowsPerPage,
          onPageChange: page.handlePageChange,
          onRowsPerPageChange: page.handleRowsPerPageChange,
        }}
      />
    </>
  );
};

export default OrganizationsV2;
